import declare from "dojo/_base/declare";
import PostRequest from "csi/comm/PostRequest";
import Controller from "csi/action/Controller";
import util from "csi/util";
import { SUPPORTED_FILE_EXTENSION } from "./DGaaSForm";
import { setLocationRevisionUrl } from "csi/router";
import locale from "csi/locale";

const SOURCE_FILE_FIELD = "NewSourceFile";
const DGaaSUploadController = declare(Controller, {
	/**
	 * @override
	 * Set the parameters to the call method DGaaS UpdateTemplate
	 */
	process() {
		const fd = this.getFormData();
		const req = new PostRequest("DocumentGenerator", "UpdateTemplate");
		req.addParameter("URL", this.m_proxy.m_urlNode);
		req.addFiles(fd.getFieldValueAsFile(SOURCE_FILE_FIELD), "SourceFile");
		this.waitForPublish(req.post());
	},

	/**
	 * @override
	 * Validates the attached file when saving.
	 * Ensures that only files with the '.docx' extension are supported.
	 */
	onValidate() {
		const fd = this.getFormData();
		const fileToRead = fd.getFieldValue(SOURCE_FILE_FIELD);
		const ext = util.getFileExtension(fileToRead);
		if (!SUPPORTED_FILE_EXTENSION.includes(ext)) {
			throw new Error(locale.resource("UnsupportedDGaaSTemplateFile"));
		}
	},

	/**
	 * @override
	 * Navigate to new revision after uploading a new template
	 */
	postProcessSuccess() {
		const master = this.getParent();
		if (master.$Type == "DGaaSTemplate") {
			const revisionUrl = master.Revisions.last();
			return setLocationRevisionUrl(revisionUrl);
		} else {
			return this.widget.refreshData();
		}
	},

	/**
	 * @override
	 *  Return newly created DGaaSTemplateRevision
	 */
	getNewNodes() {
		if (!this.m_response) {
			return this.inherited(arguments);
		}
		return this.m_response.getNodesOfType("DGaaSTemplate");
	},
});
export = DGaaSUploadController;